export default __webpack_public_path__ + "static/media/infoPastaCompartilhada.f4c8a95c.svg";